'use client';

export default function BackButton() {
  return (
    <button data-component-id="components/common/BackButton.tsx:5:4" data-component-path="components/common/BackButton.tsx" data-component-line="5" data-component-end-line="10" data-component-file="BackButton.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22mb-6%20text-accent%20font-semibold%20hover%3Aunderline%22%2C%22textContent%22%3A%22%E2%86%90%20Back%22%7D"
      onClick={() => window.history.back()}
      className="mb-6 text-accent font-semibold hover:underline"
    >
      &larr; Back
    </button>
  );
}
